import { Sparkles, Heart } from "lucide-react";
import { ALL_STEPS, STEP_META, RECALL_SCENARIOS, MIDDLE_STEP_IDS } from "../constants";

const SelectorPill = ({ active, accent, icon: Icon, label, onClick, testId }) => (
    <button
        type="button"
        onClick={onClick}
        className="shrink-0 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-md border text-[11px] font-medium transition-all hover:border-foreground/40"
        style={
            active
                ? { borderColor: accent, background: accent, color: "#fff" }
                : {
                      borderColor: "hsl(var(--border))",
                      background: "hsl(var(--surface))",
                      color: "hsl(var(--muted-foreground))",
                  }
        }
        data-testid={testId}
    >
        <Icon className="h-3 w-3" strokeWidth={1.75} />
        <span>{label}</span>
    </button>
);

// ═══════════════════════════════════════════════════════════════════════════
// Ekran seçici (merchant-only) — 3 satır
//   Satır 1: 3 Smart Recall senaryosu (Karşılama · İlk Ziyaret / Kısmi / Tam)
//   Satır 2: Ana adımlar (Temel, Fit, 4 vücut ölçüsü)
//   Satır 3: Terminal ekranlar (Sonuç, Nazik Ret)
// ═══════════════════════════════════════════════════════════════════════════
export const ScreenSelector = ({
    step, previewRefusal, onSelectStep, recallScenario, onSelectRecall,
    accent, showRefusalPill, smartRecallEnabled, fastPathMode, visibleSteps,
}) => {
    const steps = Array.isArray(visibleSteps) && visibleSteps.length ? visibleSteps : ALL_STEPS;
    const resultIdx = steps.indexOf("result");
    const isResultActive = step === resultIdx && !previewRefusal;
    // "complete" pill'in label'ı fastPathMode'a göre değişir
    const scenarioLabel = (id) => {
        if (id === "complete") {
            return fastPathMode === "always_confirm" ? "Karşılama · Onay" : "Karşılama · Tam";
        }
        return RECALL_SCENARIOS.find((s) => s.id === id)?.label;
    };
    const visibleMiddleIds = MIDDLE_STEP_IDS.filter((id) => steps.includes(id));
    return (
        <div className="space-y-1.5" data-testid="fms-screen-selector">
            {/* Satır 1 — Smart Recall senaryoları (toggle açıkken) */}
            {smartRecallEnabled && (
                <div className="flex flex-wrap items-center gap-1" data-testid="fms-recall-selector">
                    {RECALL_SCENARIOS.map((s) => {
                        const active = step === 0 && recallScenario === s.id;
                        return (
                            <SelectorPill
                                key={s.id}
                                active={active}
                                accent={accent}
                                icon={Sparkles}
                                label={scenarioLabel(s.id)}
                                onClick={() => onSelectRecall(s.id)}
                                testId={`fms-recall-scenario-${s.id}`}
                            />
                        );
                    })}
                </div>
            )}
            {/* Satır 2 — Ana adımlar */}
            <div className="flex flex-wrap items-center gap-1">
                {visibleMiddleIds.map((id) => {
                    const idx = steps.indexOf(id);
                    const meta = STEP_META[id];
                    const active = idx === step && !previewRefusal;
                    const Icon = meta.icon;
                    return (
                        <SelectorPill
                            key={id}
                            active={active}
                            accent={accent}
                            icon={Icon}
                            label={meta.short}
                            onClick={() => onSelectStep(idx, false)}
                            testId={`fms-screen-selector-${id.replace(":", "-")}`}
                        />
                    );
                })}
            </div>
            {/* Satır 3 — Terminal ekranlar */}
            <div className="flex flex-wrap items-center gap-1">
                <SelectorPill
                    active={isResultActive}
                    accent={accent}
                    icon={STEP_META.result.icon}
                    label={STEP_META.result.short}
                    onClick={() => onSelectStep(resultIdx, false)}
                    testId="fms-screen-selector-result"
                />
                {showRefusalPill && (
                    <SelectorPill
                        active={previewRefusal}
                        accent={accent}
                        icon={Heart}
                        label="Nazik Ret"
                        onClick={() => onSelectStep(resultIdx, true)}
                        testId="fms-screen-selector-refusal"
                    />
                )}
            </div>
        </div>
    );
};
